import { format } from "date-fns";

import { DEFAULT_DATE_FORMAT } from "constants/index";

export const formatDate = (
  dueDate: number | Date,
  dateFormat: string = DEFAULT_DATE_FORMAT
) => {
  return format(dueDate, dateFormat);
};
